import React from 'react';
import { Container, Typography, Box, Link } from '@mui/material';
import { Trans } from '@lingui/react/macro';
import { Link as RouterLink } from 'react-router';

const PrivacyPolicyPage: React.FC = () => {
    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Typography variant="h3" gutterBottom>
                <Trans>Privacy Policy</Trans>
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography>
                    <Trans>
                        We respect your privacy. This application stores only the data necessary to provide the service and your account access. We do not use non-essential cookies or tracking without your consent.
                    </Trans>
                </Typography>
                <Typography>
                    <Trans>
                        You may request an export of your personal data or request deletion of your account by visiting your Profile or contacting support.
                    </Trans>
                </Typography>
                <Typography>
                    <Trans>
                        For questions, contact: info@iokrono.com.
                    </Trans>
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    <Trans>Last updated:</Trans> {new Date().toISOString().slice(0, 10)}
                </Typography>
                <Box>
                    <Link component={RouterLink} to="/terms"><Trans>Terms of Service</Trans></Link>
                </Box>
            </Box>
        </Container>
    );
};

export default PrivacyPolicyPage;
